import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { sortMaterialResponse } from "@miplatform/utils";

export const useImportPlanAreaOptionsViewModel = ({ area, stateManager }) => {
  const [materials, setMaterials] = useState([]);

  const getMaterials = () => {
    stateManager.run(async () => {
      const planAreaMaterialId =
        area?.materials?.map((m) => m.materialId) ?? [];
      const response = await homeService.materials.getAll({
        filters: { id: { in: { type: "guid", value: planAreaMaterialId } } },
      });
      if (response.status === HTTP_STATUSES.OK) {
        const mappedData = area?.materials?.map((material) => {
          const materialDetails = response.data.find(
            (item) => item.id === material.materialId
          );
          return { ...materialDetails, ...material };
        });
        const displayOrderSortedData = sortMaterialResponse(mappedData);
        setMaterials(displayOrderSortedData);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    materials,
    getMaterials,
    setMaterials,
  };
};
